import React, { useMemo } from 'react';
import {
  AppButton,
  Box,
  Inscription,
  RoundDoneIcon,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';

import { useCancelPlanTerminationSuccessModalStore,usePlanTerminationModalStore } from './store';

export const CancelPlanTerminationSuccessModal = () => {
  const modalVisible = useCancelPlanTerminationSuccessModalStore((state) => state.modalVisible);
  const handleChangeVisibility = useCancelPlanTerminationSuccessModalStore((state) => state.handleChangeVisibility);

  const planName = usePlanTerminationModalStore((state) => state.planName);

  const headerText = useMemo(() => `Termination canceled for ${planName}`,[planName]);

  const onSubmit = () => {
    handleChangeVisibility(false);
    location.reload();
  };
  return (
    <ModalWrapper testId="CancelPlanTerminationSuccessModal" visible={modalVisible} onSetVisible={onSubmit}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing24' }}>
        <RoundDoneIcon />
        <Inscription
          data-testid="CancelPlanTerminationSuccessModal_header"
          margin={{ top: 'spacing12', bottom: 'spacing24' }}
          textAlign="center"
          size="24px"
          weight={700}
          lineHeight="32px"
        >
          {headerText}
        </Inscription>

        <AppButton
          testId="CancelPlanTerminationSuccessModal"
          onClick={onSubmit}
          width="200px"
        >
          Got It!
        </AppButton>
      </Box>
    </ModalWrapper>
  );
};